import React from 'react';
import HomeLayout from './HomeLayout';
import { HOMEPAGE_ABOUT } from '../common/constants';

const AboutUsLayout = props => {
    return <HomeLayout {...props} subPage={HOMEPAGE_ABOUT} />;
};

export default AboutUsLayout;
